module.exports = __webpack_public_path__ + "media/stockholm/subway_hex-6c05ce53.jpg";